import { render, staticRenderFns } from "./createOrder.vue?vue&type=template&id=db1497a2&scoped=true&"
import script from "./createOrder.vue?vue&type=script&lang=js&"
export * from "./createOrder.vue?vue&type=script&lang=js&"
import style0 from "./createOrder.vue?vue&type=style&index=0&id=db1497a2&scoped=true&lang=css&"
import style1 from "./createOrder.vue?vue&type=style&index=1&id=db1497a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1497a2",
  null
  
)

export default component.exports